export type Kind = "boq" | "timeline";
export type Scalar = string | number | boolean | null | number[];
export type Values = Record<string, Scalar>;
export interface Owner { instance: string; user_id: number; name: string; lang: string; company_id: number; company_name: string; workspace: string }
export interface Field { name: string; string: string; type: string; required?: boolean; selection?: [string, string][]; table_ref?: string; options?: { id: number; name: string }[] }
export interface Row { key: string; id: number | null; values: Values }
export interface Draft { header: Values; tables: Record<string, Row[]> }
export interface Snapshot {
    schema: 1; kind: Kind; owner: Owner; project: { id: number; name: string }; document_id: number | null;
    state: string; editable: boolean; version: string | null; header_fields: Field[];
    tables: Record<string, { label: string; fields: Field[]; defaults: Values; create: boolean; write: boolean; delete: boolean }>;
    draft: Draft;
}
export interface SyncBody { schema: 1; owner: Owner; project_id: number; document_id: number | null; base_version: string | null; operation_id: string; draft: Draft }
export interface Operation { body: SyncBody; revision: number }
export interface Work {
    id: string; ownerKey: string; base: Snapshot; draft: Draft; revision: number; savedAt: number;
    dirty: boolean; ready: boolean; aliases?: Record<string, Record<string, string>>; operation?: Operation; error?: string; conflict?: Snapshot; status?: "syncing" | "conflict" | "error";
    /** Stable, device-only IDs let the regular forms refer to unsynchronized records. */
    localId?: number;
    localRows?: Record<string, Record<string, number>>;
}
export interface SyncAnswer { snapshot: Snapshot; key_map: Record<string, Record<string, string>> }
export const ownerKey = (owner: Owner) => `${owner.instance}:${owner.user_id}`;
export const clone = <T,>(value: T): T => structuredClone(value);

/** Editors may still hold a temporary key when an acknowledgement assigns a server ID. */
export function resolveRowKey(work: Work, table: string, key: string): string {
    const aliases = work.aliases?.[table];
    const visited = new Set<string>();
    while (aliases?.[key] && aliases[key] !== key && !visited.has(key)) {
        visited.add(key); key = aliases[key]!;
    }
    return key;
}
